import { motion } from "framer-motion"

import Intro from "../../components/intro/Intro"
import Skills from "../../components/skills/Skills"
import Projects from "../../components/projects/Projects"
import Callback from "../../components/callback/Callback"


function Home() {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <div className="container">
                <Intro />
                <Skills />
                <Projects />
                <Callback />
            </div>
        </motion.div>
    )
}


export default Home